import { render } from "./CatalogOptions.vue?vue&type=template&id=3aa8d070"
import script from "./CatalogOptions.vue?vue&type=script&lang=js"
export * from "./CatalogOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__